// src/screens/Client/support/RaiseTicketModal.jsx
import React, { useContext, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { X } from "lucide-react";
import MyContext from "../../MyContext";

const DEPTS = ["Finance", "Orders", "Technical", "General"];

const RaiseTicketModal = ({ open, onClose, userID }) => {
    const { baseUrl, config } = useContext(MyContext);

    const [subject, setSubject] = useState("");
    const [department, setDepartment] = useState(DEPTS[0]);
    const [description, setDescription] = useState("");
    const [saving, setSaving] = useState(false);

    const ticketCode = useMemo(() => {
        // simple readable id for UI/API
        const t = Date.now().toString().slice(-8);
        return `T${t}`;
    }, [open]);

    const canSubmit = subject.trim() && description.trim();

    const submit = async () => {
        if (!canSubmit) return toast.info("Please fill subject and description");
        setSaving(true);
        try {
            const body = JSON.stringify({
                ticketCode: "",
                subject: subject.trim(),
                description: description.trim(),
                customerid: null,        // as requested
                userid: userID || "",
                department,
            });

            const res = await fetch(`${baseUrl}/api/Support/v1.0/raiseSupportTicket`, {
                method: "POST",
                headers: { ...config.headers, "Content-Type": "application/json" },
                body,
            });

            const data = await res.json();
            if (data?.responseCode === "00") {
                toast.success("Ticket raised successfully");
                setSubject("");
                setDepartment(DEPTS[0]);
                setDescription("");
                onClose(true);
            } else {
                toast.error(data?.responseMessage || "Failed to raise ticket");
            }
        } catch (e) {
            console.error(e);
            toast.error("Error raising ticket");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className={`modal ${open ? "d-block show" : ""}`} tabIndex="-1" style={{ background: open ? "rgba(0,0,0,0.35)" : "transparent" }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content client-ticket-modal">
                    <div className="modal-header">
                        <h5 className="modal-title">Raise Support Ticket</h5>
                        <button className="btn btn-sm btn-light" onClick={() => onClose(false)}>
                            <X size={18} />
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-2 small text-muted">Ticket Code: <strong>{ticketCode}</strong></div>
                        <div className="mb-3">
                            <label className="form-label">Subject</label>
                            <input className="form-control" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Brief subject" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Department</label>
                            <select className="form-select" value={department} onChange={(e) => setDepartment(e.target.value)}>
                                {DEPTS.map((d) => (
                                    <option key={d} value={d}>{d}</option>
                                ))}
                            </select>
                        </div>
                        <div className="mb-1">
                            <label className="form-label">Description</label>
                            <textarea className="form-control" rows={4} value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Describe your issue..." />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-outline-secondary" onClick={() => onClose(false)}>Cancel</button>
                        <button className="btn btn-primary" onClick={submit} disabled={!canSubmit || saving}>
                            {saving ? "Submitting..." : "Submit Ticket"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RaiseTicketModal;
